<template>
  <HeaderTitle :back-target-func="changeView">
    <template #top>{{ t("code.scan.screen.title") }}</template>
    <template #bottom>{{ t("code.web.subtitle") }}</template>
  </HeaderTitle>

  <div>
    <h2>{{ t("registration.subtitle") }}</h2>
    <div class="w-96 flex flex-col items-center mx-auto mb-14 text-left">
      <div class="pt-8 w-full">
        <InputElement
          id="userName"
          v-model="userName"
          :label="t('registration.name.headline')"
          max-length="255"
          required
        />
      </div>
      <div class="pt-4 w-full">
        <InputElement
          id="userEmail"
          v-model="userEmail"
          type="email"
          :label="t('registration.mail.headline')"
          max-length="255"
          required
        />
      </div>
      <div class="pt-4 w-full">
        <PasswordElement
          id="password"
          v-model="password"
          type="password"
          :label="t('registration.password.headline')"
          required
          @update-field="(value) => (password = value)"
        />
        <PasswordValidationInfo
          :password="password"
          @is-password-valid="setIsPasswordValid"
        />
      </div>

      <PasswordElement
        id="confirmPassword"
        v-model="confirmPassword"
        class="w-full"
        type="password"
        :label="t('registration.password.repeat.headline')"
        required
        @update-field="(value) => (confirmPassword = value)"
      />
    </div>

    <div class="text-error w-96 m-auto">
      {{ error }}
    </div>
    <div class="flex flex-col justify-center items-center mt-4 gap-4">
      <BaseButton
        variant="primary"
        :disabled="
          !isPasswordValid ||
          !userName ||
          !userEmail ||
          (password && confirmPassword && password !== confirmPassword)
        "
        @click="handleSubmit"
        >Registrieren</BaseButton
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import InputElement from "../form/InputElement.vue";
import PasswordElement from "../form/PasswordElement.vue";
import BaseButton from "../layout/button/BaseButton.vue";
import { registerAppUser } from "../../../api/v2/register.ts";
import { useClientStore } from "../../../store/v2/client";
import { useConsentStore } from "../../../store/v2/consent.ts";
import axios from "axios";
import HeaderTitle from "../layout/header/HeaderTitle.vue";
import { useI18n } from "vue-i18n";
import PasswordValidationInfo from "~/components/v2/login/PasswordValidationInfo.vue";

const { t } = useI18n();

const clientStore = useClientStore();
const consentStore = useConsentStore();

const password = ref("");
const confirmPassword = ref("");
const userEmail = ref("");
const userName = ref("");
const error = ref("");
const isPasswordValid = ref(false);

defineProps({
  open: Boolean,
});

const emit = defineEmits(["change-view"]);

function setIsPasswordValid(valid: boolean) {
  isPasswordValid.value = valid;
}

async function handleSubmit() {
  try {
    const response = await registerAppUser(
      userEmail.value,
      userName.value,
      password.value,
      clientStore.code,
      consentStore.privacyPolicy,
      consentStore.termsOfUse,
      consentStore.allowTracking
    );
    if (response.status === 200) {
      emit("change-view", "login");
    } else {
      error.value = t("auth.failure.error.register");
    }
  } catch (err) {
    if (axios.isAxiosError(err)) {
      error.value = t("auth.failure.error.register");
    }
  }
}

function changeView() {
  emit("change-view", "accept");
}
</script>
